import { useEffect, useRef } from 'react';
import config from '../config';

// Polls the events dataversion endpoint on an interval and invokes onVersionChange
// whenever the version differs from the last observed value. The first poll only
// records a baseline — it does not trigger a refresh.
function useDataVersionPolling(onVersionChange, intervalMs = config.dataVersionPollIntervalMs) {
    const lastVersionRef = useRef(null);
    const callbackRef = useRef(onVersionChange);
    callbackRef.current = onVersionChange;

    useEffect(() => {
        let cancelled = false;

        const checkVersion = async () => {
            try {
                const response = await fetch(`${config.apiBaseUrl}${config.endpoints.events.version}`);
                const version = await response.text();
                if (cancelled) return;

                if (lastVersionRef.current === null) {
                    lastVersionRef.current = version;
                    return;
                }

                if (version !== lastVersionRef.current) {
                    lastVersionRef.current = version;
                    callbackRef.current();
                }
            } catch (error) {
                // Ignore transient network errors; the next interval will retry.
            }
        };

        const intervalId = setInterval(checkVersion, intervalMs);
        return () => {
            cancelled = true;
            clearInterval(intervalId);
        };
    }, [intervalMs]);
}

export default useDataVersionPolling;
